import React from 'react'
import { resetSchema } from '@/src/types'
import { useForm } from 'react-hook-form'
import Button from '@/src/components/button'
import { yupResolver } from '@hookform/resolvers/yup'
import { FormTextField, PasswordField } from '@/src/components/form-components'
import { Typography } from '@mui/material'

interface FormData {
  newPassword: string
  confirmationCode: string
}
export interface Props {
  loading: boolean
  reSendCode: (data: string) => void
  onSubmit: (formData: FormData) => void
  userEmail: string
}
const ResetForm = ({ loading, onSubmit, reSendCode, userEmail }: Props) => {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<FormData>({ resolver: yupResolver(resetSchema) })

  const formSubmit = (data: FormData) => {
    onSubmit(data)
  }

  return (
    <div>
      <div className="text-center flex flex-col justify-center pb-10">
        <Typography variant="h5">We’ve sent a verification code to:</Typography>
        <Typography variant="subtitle1">{userEmail || 'userEmail'}</Typography>{' '}
      </div>

      <form className=" flex flex-col gap-4" onSubmit={handleSubmit(formSubmit)}>
        <FormTextField
          label="Verification Code"
          fieldClass="w-[20.438rem] sm:w-[26.5rem]"
          placeholder="Verification Code"
          validation={register('confirmationCode')}
          error={!!errors.confirmationCode}
          helperText={errors.confirmationCode?.message}
          InputLabelProps={{
            className: 'text-secondary-main'
          }}
        />
        <PasswordField
          label="New Password"
          passwordKey="forgot"
          fieldClass="w-[20.438rem] sm:w-[26.5rem]"
          placeholder="New Password"
          validation={register('newPassword')}
          error={!!errors.newPassword}
          helperText={errors.newPassword?.message}
          InputLabelProps={{
            className: 'text-secondary-main'
          }}
        />
        <Button
          divClass="mt-6 w-[20.438rem] sm:w-[26.5rem]"
          text="Reset Password"
          onClick={() => {}}
          loading={loading}
          type="submit"
          fullwidth={true}
        />
        <div className="text-center mt-10">
          <Typography variant="body2" color="text.secondary">
            If it doesn’t arrive within a few minutes,
          </Typography>
          <div className="flex justify-center">
            <Typography variant="body2" color="text.secondary">
              check your spam folder or{' '}
            </Typography>
            <Typography
              variant="body2"
              color="primary.main"
              onClick={() => reSendCode(userEmail)}
              className="cursor-pointer ml-2 font-semibold"
            >
              send the email again
            </Typography>
          </div>
        </div>
      </form>
    </div>
  )
}

export default ResetForm
